import axios from 'axios';

export function fetchApplication(payload) {
    return axios.get('applications/' + payload);
}

export function fetchApplications() {
    return axios.get('/applications');
}

export function createApplication(payload) {
    return axios.post('/applications', payload);
}

export function validateToken(payload) {
    return axios.get('/applications/' + payload + '/validate');
}

export function approveApplication(payload) {
    return axios.post('/applications/approve', payload);
}

export function rejectApplication(payload) {
    return axios.put(`/applications/${payload}/reject`);
}
